export function getRegulatoryBotIconUrl() {
  return window.config?.regulatoryBotIcon || null;
}

export function getPedagogyBotIconUrl() {
  return window.config?.pedagogyBotIcon || null;
}

export function badgeIconFromFlags({ approvedByPmr, pedagogical } = {}) {
  if (approvedByPmr === true) return getRegulatoryBotIconUrl();
  if (pedagogical === true) return getPedagogyBotIconUrl();
  return null;
}

export function badgeKeyFromIcon(icon) {
  if (typeof icon !== 'string' || !icon) return null;
  const regulatory = getRegulatoryBotIconUrl();
  const pedagogical = getPedagogyBotIconUrl();
  if (
    (regulatory && icon === regulatory) ||
    icon.includes('regulatoryBotIcon') ||
    icon.includes('botTypeRegulatory')
  ) {
    return 'regulatory';
  }
  if (
    (pedagogical && icon === pedagogical) ||
    icon.includes('pedagogyBotIcon') ||
    icon.includes('botTypePedagogical')
  ) {
    return 'pedagogical';
  }
  return null;
}

export function isBadgeIcon(value) {
  return typeof value === 'string' && value.startsWith('http');
}

/** Normalize draft/config: derive checkboxes + icon URL, drop legacy botType. */
export function normalizeBadgeFields(source = {}) {
  const regulatoryUrl = getRegulatoryBotIconUrl();
  const pedagogicalUrl = getPedagogyBotIconUrl();
  let icon = null;
  const key = badgeKeyFromIcon(source.icon);
  if (key === 'regulatory') icon = regulatoryUrl;
  else if (key === 'pedagogical') icon = pedagogicalUrl;
  else if (source.botType === 'regulatory' || source.approvedByPmr === true) {
    icon = regulatoryUrl;
  } else if (source.botType === 'pedagogical') {
    icon = pedagogicalUrl;
  } else if (isBadgeIcon(source.icon)) {
    icon = source.icon;
  }

  return {
    icon,
    approvedByPmr: icon != null && icon === regulatoryUrl,
    pedagogical: icon != null && icon === pedagogicalUrl,
  };
}
